/** @jsxImportSource @emotion/react */
import {css, keyframes} from "@emotion/react";
import React from "react";
import * as Branding from "js/common/branding-constants";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const pulseLightTheme = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(74, 137, 220, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(74, 137, 220, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(74, 137, 220, 0);
  }
`;

const pulseDarkTheme = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(249, 236, 51, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(249, 236, 51, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(249, 236, 51, 0);
  }
`;

const buttonContainerStyles = theme => css`
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  padding: 4px;
  margin-bottom: 0;
  background: ${theme.palette.primary.main};
  font-family: ${theme.typography.fontFamily};

  &:hover {
    animation: ${theme.themeId === "light" ? pulseLightTheme : pulseDarkTheme} 1.5s infinite;
  }
`;

const buttonContentStyles = theme => css`
  background-color: ${theme.palette.primary.main};
  color: ${theme.palette.text.inverted};
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
`;


const AiAssistantButton = ({onClick, label = Branding.aiAssistantName, style = {}, className}) => {
  const iconStyles = css`
    font-size: 20px;
    margin-right: ${label === "" ? 0 : 3}px;
    margin-top: -8px; // we use negative margins here to avoid the increased icon height from making the button too high
    margin-bottom: -4px;
  `;

  const {theme} = React.useContext(CustomThemeContext);
  return (
      <button className = {className} css={buttonContainerStyles(theme)} style={style} onClick={onClick} data-test-id={"ai-assistant-button"}>
        <div css={buttonContentStyles(theme)}>
          <i css={iconStyles} className={"bhi-magic"} />
          {label}
        </div>
      </button>
  );
};

export default AiAssistantButton;